import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PASSWORD_MIN_LENGTH: number = 8;
export const PASSWORD_MAX_LENGTH: number = 60;

export interface PasswordRule {
  key: string;
  label: string;
  test: (value: string) => boolean;
}

// Mirrors the password policy enforced by erpclass-auth (SignupRequest/ResetRequest/SetPasswordRequest).
// Keep both in sync: a rule the backend enforces but the form does not shows up as a rejected submit.
export const PASSWORD_RULES: readonly PasswordRule[] = [
  { key: 'length', label: `No mínimo ${PASSWORD_MIN_LENGTH} caracteres`, test: (value) => value.length >= PASSWORD_MIN_LENGTH },
  { key: 'uppercase', label: 'Uma letra maiúscula (A-Z)', test: (value) => /[A-Z]/.test(value) },
  { key: 'lowercase', label: 'Uma letra minúscula (a-z)', test: (value) => /[a-z]/.test(value) },
  { key: 'number', label: 'Um número (0-9)', test: (value) => /\d/.test(value) },
  { key: 'symbol', label: 'Um caractere especial (ex.: ! @ # $ %)', test: (value) => /[^A-Za-z0-9]/.test(value) },
];

export const passwordPolicy: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value: unknown = control.value;
  if (typeof value !== 'string' || value === '') {
    return null;
  }
  const valid: boolean = value.length <= PASSWORD_MAX_LENGTH && PASSWORD_RULES.every((rule) => rule.test(value));
  return valid ? null : { passwordPolicy: true };
};
